import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noshow',
  templateUrl: './noshow.component.html',
  styleUrls: ['./noshow.component.scss']
})
export class NoshowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
